"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowFactoryErrors__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  name: "CreateCallerNotContract",
  type: "error"
}];

class TitleEscrowFactoryErrors__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TitleEscrowFactoryErrors__factory = TitleEscrowFactoryErrors__factory;

_defineProperty(TitleEscrowFactoryErrors__factory, "abi", _abi);